import React, { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import Dashboard from '@modules/dashboard/Dashboard';
import BankCodes from '@modules/bankCodes/BankCodes';
import CreateWallet from '@modules/wallets/CreateWallet';
import EmptyScreen from '@components/EmptyScreen';
import GenerateReport from '@modules/generateReport/GenerateReport';
import Balances from '@modules/finances/Balances';
import MyAccount from '@modules/myAccount/MyAccount';
import Notifications from '@modules/notifications/Notifications';
import Pricing from '@modules/pricing/Pricing';
import RequestWithdrawal from '@modules/finances/RequestWithdrawal';
import TopUpCrypto from '@modules/finances/TopUpCrypto';
import TopUpPayoutBalance from '@modules/finances/TopUpPayoutBalance';
import Wallets from '@modules/wallets/Wallets';

import { crudActions } from '@sm/services/crudActions';
import { FETCH_PERMISSIONS } from '@sm/actions/types';
import { setUserInfo } from '@sm/store/authSlice';
import { showAlert } from '@sm/store/alertSlice';
import { useCheckCategoryAccess } from '@sm/hooks/useCheckCategoryAccess';

const Module = () => {
  const dispatch = useDispatch();
  const { fireblocksEnabled } = useSelector((state) => state.auth);

  useEffect(() => {
    crudActions.get(`v1/myaccount/me`).then(
      (user) => {
        if (user) {
          dispatch(setUserInfo({
            type: FETCH_PERMISSIONS,
            permissions: user.permissions,
            roleId: user.roleId,
            userId: user.id,
            wlOtcEnabled: user.wlOtcEnabled,
            fireblocksEnabled: user.fireblocksEnabled,
            topUpFeeEnabled: user.topUpFeeEnabled
          }));
        }
      }
    ).catch(
      err => {
        localStorage.removeItem("loginAsUser");
        localStorage.removeItem("loginAsUserEmail");
        dispatch(showAlert('danger', err?.message));
      }
    );
  }, [dispatch]);

  return (
    <Routes>
      <Route path="/" element={ <EmptyScreen /> }/>
      <Route path="/my-account" element={ <MyAccount /> }/>
      
      {useCheckCategoryAccess("DASHBOARD") && <Route path="/dashboard" element={ <Dashboard /> }/>}
      {useCheckCategoryAccess("REPORTS") && <Route path="/generate-reports" element={ <GenerateReport /> }/>}
      {useCheckCategoryAccess("BANKLIST") && <Route path="/bank-codes" element={ <BankCodes /> } />}
      {useCheckCategoryAccess("DASHBOARD") && <Route path="/local-balance" element={ <Balances /> } />}
      {useCheckCategoryAccess("DASHBOARD") && <Route path="/global-balance" element={ <Balances /> } />}
      {useCheckCategoryAccess("DASHBOARD") && <Route path="/top-up-payout-balance" element={ <TopUpPayoutBalance /> } />}
      {useCheckCategoryAccess("DASHBOARD") && fireblocksEnabled && <Route path="/top-up-crypto" element={ <TopUpCrypto /> } />}
      {useCheckCategoryAccess("DASHBOARD") && <Route path="/request-withdrawal" element={ <RequestWithdrawal /> } />}
      {useCheckCategoryAccess("DASHBOARD") && <Route path="/pricing" element={ <Pricing /> } />}
      {useCheckCategoryAccess("DASHBOARD") && <Route path="/wallets" element={ <Wallets /> } />}
      {useCheckCategoryAccess("DASHBOARD") && <Route path="/create-wallet" element={ <CreateWallet /> } />}
      {useCheckCategoryAccess("DASHBOARD") && <Route path="/my-notifications" element={ <Notifications /> } />}
    </Routes>
  );
};

export default Module;